/**
 * Attar / Ittar collections: Floral / Woody / Oriental client-side filter.
 * Grid items use `data-attar-fragrances` (space-separated keys from `attar-product-fragrances`).
 */
(() => {
  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const root = document.getElementById('AttarFragranceFilter');
  if (!root) return;
  const grid = document.getElementById('ProductGridContainer');
  if (!grid) return;

  const items = () => grid.querySelectorAll('.grid__item[data-attar-fragrances]');
  const emptyEl = document.getElementById('AttarFragranceFilterEmpty');

  function setActive(btn) {
    root.querySelectorAll('[data-attar-fragrance-filter]').forEach((b) => {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  }

  function apply(filter) {
    const normalizedFilter = normalize(filter);
    let visible = 0;
    items().forEach((li) => {
      const raw = normalize(li.getAttribute('data-attar-fragrances'));
      const tags = raw ? raw.split(/\s+/) : [];
      const show = normalizedFilter === 'all' || tags.indexOf(normalizedFilter) !== -1;
      li.classList.toggle('attar-fragrance-filter--hidden', !show);
      if (show) visible += 1;
    });
    if (emptyEl) {
      emptyEl.hidden = normalizedFilter === 'all' || visible > 0;
    }
  }

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-attar-fragrance-filter]');
    if (!btn || !root.contains(btn)) return;
    const filter = btn.getAttribute('data-attar-fragrance-filter') || 'all';
    setActive(btn);
    apply(filter);
  });

  document.addEventListener('tatha:product-grid-updated', () => {
    const allBtn = root.querySelector('[data-attar-fragrance-filter="all"]');
    if (allBtn) {
      setActive(allBtn);
      apply('all');
    }
  });
})();
